import React from "react"
import PropTypes from "prop-types"
import ItemNameValueShape from "../../state/shapes/ItemNameValueShape"
import Widget from "../layout/widget/Widget"
import DoughnutChart from "../charts/generic/DoughnutChart"
import ChartComparison from "../ChartComparison"

function AgreedLAndDCompleted({ exportEndpoint, appliedFilters, data, subtitleKey, sampleSize }) {
  const hasComparisonData = false// !!(data[1] && data[1].value)
  const titleKey = "Widgets.AgreedLAndDCompleted.Title"
  return (
    <Widget
      columns={1}
      titleKey={titleKey}
      helpKey="Widgets.AgreedLAndDCompleted.Help"
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
      sampleSize={sampleSize}
    >
      <DoughnutChart
        data={data}
        suffix="%"
        chartThreshold={0}
        hasComparison={hasComparisonData}
        titleKey={titleKey}
        subtitleKey={subtitleKey}
      >
        {hasComparisonData && (
          <ChartComparison
            baseValue={data[0].value}
            comparisonOneValue={data[1] && data[1].value ? data[1].value : null}
            comparisonOneText="Common.LastSixMonths"
            comparisonTwoValue={data[2] && data[2].value ? data[2].value : null}
            comparisonTwoText="Common.LastTwelveMonths"
            usePercentage
            increaseIsGood
            translateText
          />
        )}
      </DoughnutChart>
    </Widget>
  )
}

AgreedLAndDCompleted.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(ItemNameValueShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
  sampleSize: PropTypes.object
}

export default AgreedLAndDCompleted



// WEBPACK FOOTER //
// ./src/components/widgets/AgreedLAndDCompleted.jsx